import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { useAppSelector } from '../../../redux/store';
import useHttps from '../../useHttps';

const useDeleteAccount = () => {
    const { authData } = useAppSelector((state) => state.auth);
    const request = useHttps();
    const [loading, setLoading] = useState(false);

    const onDeleteAccountError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while deleting account.',
        );
    };

    const onDeleteAccountSuccess = (callbackFn?: () => void) => ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        toast.success(message ?? 'Account deleted successfully.');
        callbackFn?.();
    };

    const deleteAccount = (data: Record<string, string>, callbackFn?: () => void) => {
        const url: HttpConfig = {
            url: `api/v1/company/${authData?.user?.companyId}`,
            method: 'delete',
            data
        };

        request(url, onDeleteAccountSuccess(callbackFn), setLoading, onDeleteAccountError);
    };

    return { deleteAccount, loading };
};

export default useDeleteAccount;
